<template>
  <div id="app">
    <router-view v-if="isMobile" />
    <div v-else class="mobile-tip">
      <div class="tip-box">
        <div class="tip-icon">📱</div>
        <h2 class="tip-title">请用微信扫码打开</h2>
        <p class="tip-desc">本页面仅支持手机访问</p>
        <p class="tip-sub">请使用微信扫描下方二维码</p>
        <div class="tip-footer">© 智猎AI招聘</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    }
  },
  created() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
  },
  methods: {
    checkDevice() {
      const ua = navigator.userAgent || ''
      const uaLower = ua.toLowerCase()

      // 桌面系统黑名单：只要检测到以下任一 UA 标识，直接判定为桌面
      const desktopRegex = /Windows NT|Macintosh|Mac OS X|Linux.*X11|Linux.*Ubuntu|Linux.*Fedora|Linux.*CentOS|Linux.*Chrome OS|Win64|WOW64|x64/i

      // 移动设备白名单：包含以下 UA 标识才判定为手机
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|MicroMessenger|micromessenger|HarmonyOS|hongmeng/i

      // 微信内打开：识别为微信浏览器（MicroMessenger 已在上面，但这里额外兜底）
      const isWeChat = uaLower.indexOf('micromessenger') !== -1

      // 判断逻辑：桌面系统 UA → 提示页；移动 UA 或 屏幕宽度 < 768 → 正常访问
      let isMobileDevice = true
      if (desktopRegex.test(ua) && !isWeChat) {
        // 检测到桌面系统 UA，且不是微信 → 提示扫码
        isMobileDevice = false
      } else if (mobileRegex.test(ua)) {
        // 检测到移动 UA → 正常访问
        isMobileDevice = true
      } else if (window.innerWidth < 768) {
        // 兜底：小屏设备当作手机
        isMobileDevice = true
      } else {
        // 其他无法识别的 UA（可能是平板等），保守处理：提示页
        isMobileDevice = false
      }

      this.isMobile = isMobileDevice
    }
  }
}
</script>

<style lang="scss">
html,
body {
  touch-action: manipulation;
  /* 禁止双指缩放和双击缩放（iOS） */
  -webkit-text-size-adjust: 100%;
  /* 禁止自动调整字体大小 */
  -webkit-touch-callout: none;
  /* 禁止长按弹出系统菜单 */
  -webkit-user-select: none;
  /* 禁止用户选中文本 */
  user-select: none;
  -webkit-overflow-scrolling: touch;
  /* 滚动更顺滑（iOS） */
}

* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  /* 禁止点击时的高亮色（Android/微信） */
}

#app {
  width: 100%;
  min-height: 100vh;
}

.mobile-tip {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.tip-box {
  background: #fff;
  border-radius: 16px;
  padding: 48px 36px;
  text-align: center;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.tip-icon {
  font-size: 72px;
  line-height: 1;
  margin-bottom: 20px;
}

.tip-title {
  font-size: 28px;
  color: #1d1d1f;
  margin: 0 0 12px 0;
  font-weight: 600;
}

.tip-desc {
  font-size: 16px;
  color: #6e6e73;
  margin: 0 0 8px 0;
}

.tip-sub {
  font-size: 14px;
  color: #86868b;
  margin: 0 0 24px 0;
}

.tip-footer {
  font-size: 12px;
  color: #b0b0b5;
  margin-top: 32px;
  border-top: 1px solid #f2f2f7;
  padding-top: 20px;
}
</style>